import {createSelector} from 'reselect';
import {AppState} from '../../../index';

export const messagesSelector = () =>
  createSelector(
    (state: AppState) => ({
      messages: [...state.socialSupport.chatbot.messages].reverse(),
      isLoading: state.socialSupport.chatbot.isLoading,
      isError: state.socialSupport.chatbot.isError,
    }),
    (data) => data,
  );

export const isGeneralQuestionSelector = () =>
  createSelector(
    (state: AppState) => state.socialSupport.chatbot.isGeneralQuestion,
    (data) => data,
  );

export const isUsefulAnswerSelector = () =>
  createSelector(
    (state: AppState) => state.socialSupport.chatbot.isUsefulAnswer,
    (data) => data,
  );
